import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { setCookie, getCookie } from "./utils/cookie-manager";
import SetupAxios from "./utils/setup-axios";
import jwt_decode from "jwt-decode";

import store from "./store/index";
import App from "./App";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
// import DateFnsUtils from "@date-io/date-fns";
// import LuxonUtils from '@date-io/luxon';

import "./index.css";

// setCookie(
// 	"SIGPAPE",
// 	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiMDA2MTFhYjQtYTE3Yi00MTNiLTk1YjEtYjhiNmRiNDkzOTkzIiwiTXVzdENvbmZpcm0iOiJGYWxzZSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvdXNlcmRhdGEiOiI5OTkxMjM5ODciLCJQcm92aW5jZSI6IjE1IiwibmJmIjoxNjg1MzYyMjE4LCJleHAiOjE2ODUzNjk0MTgsImlhdCI6MTY4NTM2MjIxOH0.N7RmqqP-dZJdF7DRlifsYBW2x-ot1JA7GD8AJR-61Fw",
// 	1
// );

const cookie = getCookie("SIGPAPE");
// console.log("cookie", cookie)

let token;
let decodedToken;

if(cookie){
	token = cookie;
	// local hardcode cookie
	// token = JSON.parse(cookie);
	decodedToken = jwt_decode(token);
	console.log("decodedToken", decodedToken)
	console.log("decodedToken.unique_name", decodedToken.unique_name)
} else {
	window.location.href = "/";
}

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<Provider store={store}>
				<MuiPickersUtilsProvider utils={MomentUtils}>
					<SetupAxios>
						{/* <App token={token} userId={decodedToken.unique_name}/> */}
						<App token={token} userId={decodedToken.name}/>
					</SetupAxios>
				</MuiPickersUtilsProvider>
			</Provider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
